import type {AiChatProps} from '@AiChat/ai-chat.types';
import type {ChatOnLoadParams} from '@Components/ai-chat-window/ai-chat-window.types';
import {ChatMessagePartType} from '@Components/ai-chat-window/ai-chat-window.types';
import type {AiChatProviderOwnProps} from '@AiChat/providers/ai-chat-provider.types';
import {getAiChatSeasonFromValue} from '@AiChat/lib/ai-chat-season-library';

export async function fetchAiChatEmbedProps(): Promise<AiChatProps> {
  return (await window.PMW.readLocal('ai/chatEmbedProps')) as AiChatProps;
}

/** `ai/chatEmbedProps` sends null on-load params when the page has no request of its own; a prefilled prompt still needs params to ride on. */
export function withPrefilledPrompt(chatOnLoadParams: ChatOnLoadParams | null, initialPrompt: string | undefined): ChatOnLoadParams {
  const loadedParams = chatOnLoadParams ?? {};
  if (!initialPrompt) {
    return loadedParams;
  }

  const otherParts = (loadedParams.userRequestParts ?? []).filter((part): boolean => part.type !== ChatMessagePartType.TEXT);

  return {...loadedParams, sendOnLoad: false, userRequestParts: [{type: ChatMessagePartType.TEXT, text: initialPrompt}, ...otherParts]};
}

export function toAiChatProviderProps(props: AiChatProps): Omit<AiChatProviderOwnProps, 'isEmbedded' | 'presentation' | 'chatId'> {
  return {
    credits: props.credits,
    isPaygUserWithAiChatAccess: props.isPaygUserWithAiChatAccess,
    isReturningUser: props.isReturningUser,
    isSuperUser: props.isSuperUser,
    hasGeneratedAssets: props.hasGeneratedAssets,
    isMemoryEnabled: props.isMemoryEnabled,
    shouldShowAssetsIntroSubtitle: props.shouldShowAssetsIntroSubtitle,
    isAiChatCreateAVideoFeatureEnabled: props.isAiChatCreateAVideoFeatureEnabled,
    isTemplateRedesignFeatureEnabled: props.isTemplateRedesignFeatureEnabled,
    previewSeason: getAiChatSeasonFromValue(props.previewSeason),
    christmasGiftOffer: props.christmasGiftOffer ?? null,
    promptBoxPlaceholderKey: props.promptBoxPlaceholderKey,
    landingSource: props.landingSource ?? null,
    canUseEditableTextLayers: props.canUseEditableTextLayers,
    isMakeDesignEditableEnabled: props.isMakeDesignEditableEnabled,
    makeDesignEditableCreditCost: props.makeDesignEditableCreditCost,
    chargeForMakeTextEditable: props.chargeForMakeTextEditable,
    makeTextEditableLimit: props.makeTextEditableLimit,
    capabilityGroups: props.capabilityGroups,
  };
}
